module.exports = __webpack_public_path__ + "static/media/ic_web_app_logo.44b9e6f4.png";